var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 11H6V33H38V11ZM40 9V35H4V9H40Z",
    fill: "#00A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14H5V15H39V14Z",
    fill: "#00A88E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.608 17.456L25.176 17.536L24.36 16.352L23.024 16.872L21.88 16L20.768 16.904L19.416 16.424L18.64 17.632L17.2 17.6L16.832 18.984L15.456 19.392L15.536 20.824L14.352 21.64L14.872 22.976L14 24.12L14.904 25.232L14.424 26.584L15.632 27.36L15.6 28.8L16.984 29.168L17.392 30.544L18.824 30.464L19.64 31.648L20.976 31.128L22.12 32L23.232 31.096L24.584 31.576L25.36 30.368L26.8 30.4L27.168 29.016L28.544 28.608L28.464 27.176L29.648 26.36L29.128 25.024L30 23.88L29.096 22.768L29.576 21.416L28.368 20.64L28.4 19.2L27.016 18.832L26.608 17.456ZM24.453 20.8399L18.8399 26.453C17.6187 24.8838 17.7292 22.6139 19.1716 21.1716C20.6139 19.7292 22.8838 19.6187 24.453 20.8399ZM18.4645 20.4645C16.6312 22.2978 16.5191 25.2005 18.1284 27.1645L18.1109 27.182L18.4645 27.5355L18.818 27.8891L18.8355 27.8716C20.7995 29.4809 23.7022 29.3688 25.5355 27.5355C27.3688 25.7022 27.4809 22.7995 25.8716 20.8355L25.8891 20.818L25.5429 20.4719L25.5355 20.4645L25.5281 20.4571L25.182 20.1109L25.1645 20.1284C23.2005 18.5191 20.2978 18.6312 18.4645 20.4645ZM24.8284 26.8284C23.3861 28.2708 21.1162 28.3813 19.547 27.1601L25.1601 21.547C26.3813 23.1162 26.2708 25.3861 24.8284 26.8284Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H7V13H8V12Z",
    fill: "#00A88E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H9V13H10V12Z",
    fill: "#00A88E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H11V13H12V12Z",
    fill: "#00A88E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.9129c5c60c27527dec34471b889c78b2.svg";
export { ForwardRef as ReactComponent };